import React from "react";
import { Card } from "@/components/ui/card";

export function SummaryStat({ label, value, hint, tone = "slate", testid }) {
  const toneCls = tone === "rose" ? "text-rose-600" : "text-slate-900";
  return (
    <Card className="p-3 sm:p-4 border border-slate-200 shadow-none" data-testid={testid}>
      <div className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.1em] text-slate-500 truncate">{label}</div>
      <div
        className={`stat-num text-lg sm:text-2xl font-bold mt-1 ${toneCls} truncate`}
        data-testid={testid ? `${testid}-value` : undefined}
      >
        {value}
      </div>
      {hint && <div className="text-[11px] sm:text-xs text-slate-500 mt-0.5 truncate">{hint}</div>}
    </Card>
  );
}
